import request from '@/config/request';

/*
  获取七牛token
*/
export function getQiNiuYunToken() {
  return request({
    url: '/getQiNiuYunToken',
    method: 'post',
  });
}

export default getQiNiuYunToken;
